import { render, staticRenderFns } from "./ViewTo404.vue?vue&type=template&id=28530637&scoped=true"
import script from "./ViewTo404.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewTo404.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ViewTo404.vue?vue&type=style&index=0&id=28530637&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28530637",
  null
  
)

export default component.exports